export const filters = {
  clients_name: {
    label: 'Nom du client',
  },
  clients_type: {
    label: 'Type de client',
  },
  credit_notes_brand: {
    label: 'Nom commercial',
  },
  credit_notes_client: {
    label: 'Client',
  },
  credit_notes_doc_quarter: {
    label: 'Trimestre',
  },
  credit_notes_doc_year: {
    label: 'Année',
  },
  credit_notes_status: {
    label: 'Statut',
  },
  invoice_templates_brand: {
    label: 'Nom commercial',
  },
  invoice_templates_client: {
    label: 'Client',
  },
  invoice_templates_type: {
    label: 'Type',
  },
  invoices_brand: {
    label: 'Nom commercial',
  },
  invoices_client: {
    label: 'Client',
  },
  invoices_doc_quarter: {
    label: 'Trimestre',
  },
  invoices_doc_year: {
    label: 'Année',
  },
  invoices_status: {
    label: 'Statut',
  },
  products_activity_type: {
    label: 'Type de prestation',
  },
  products_categories: {
    label: 'Catégories',
  },
  products_status: {
    label: 'Statut',
  },
  quarter: {
    option: 'Trimestre {{quarter}} - {{year}}',
  },
  quotations_brand: {
    label: 'Nom commercial',
  },
  quotations_client: {
    label: 'Client',
  },
  quotations_doc_quarter: {
    label: 'Trimestre',
  },
  quotations_doc_year: {
    label: 'Année',
  },
  quotations_status: {
    label: 'Statut',
  },
};
